import classNames from 'classnames';
import * as React from 'react';
import Tooltip from '../Tooltip/Tooltip.js';
import TooltipBody from '../Tooltip/TooltipBody.js';
import TooltipDecoratorClass from '../Tooltip/TooltipDecorator.js';
import styles from './Realm.module.scss.js';

function RealmElClass(props) {
    return (React.createElement("div", { className: classNames(styles.container, props.className) },
        React.createElement("div", null, props.shortName)));
}
var RealmEl = TooltipDecoratorClass()(RealmElClass);
var Realm = React.memo(function (props) {
    if (!props.realmMap[props.realm]) {
        return React.createElement("div", { className: styles.container }, props.realm);
    }
    var shortName = props.realmMap[props.realm].shortName;
    return (React.createElement(RealmEl, { className: props.className, shortName: shortName, tooltipBody: React.createElement(Tooltip, null,
            React.createElement(TooltipBody, null, props.realmMap[props.realm].name)) }));
});

export { Realm as default };
//# sourceMappingURL=Realm.js.map
